import store from '../store'
import config from '../config'

import system from '../api/system'


import sdkService from '../service/sdkService'

import {
  isShare,
  getParamsFromUrl
} from '../utils/index'


// 检查版本信息
const checkVersion = () => {
  let version = localStorage.version
  if (version !== config.version) {
    localStorage.clear();
    localStorage.version = config.version
  }
}

// 每次进入应用需要清除的缓存
const clearCache = () => {
  // 清除弹窗信息
  store.commit('system/clearDialog');
  // 清除微信签名信息
  store.commit('system/updateWxSignature', null)
}

// 获取签名信息并储存
const getSignatureConfig = async function () {
  let platform = store.state.system.platform;
  // if (platform === 'wechat') await system.getSignature();
}

// 进行微信签名.
const sdkSignature = function (to, from) {
  const _signature = function () {
    let reg = new RegExp(to.fullPath.replace(/\?/, '\\?') + '$')
    if (!reg.test(location.href)) return
    if (config.payPath.includes(to.path)) {
      sdkService.config('pay')
    } else if (isShare(to.path)) {
      if (getParamsFromUrl('task') || /^\/circle\/match/.test(to.path)) {
        sdkService.config('shareTask')
      } else {
        sdkService.config('share')
      }
    } else {
      sdkService.config();
      sdkService.defaultShare()
    }
  }
  const _hasTicket = function () {
    if (store.state.system.signature) {
      _signature()
    } else {
      setTimeout(() => {
        _hasTicket()
      }, 200)
    }
  }

  setTimeout(() => {
    _hasTicket()
  }, 500)
}


export {
  clearCache,
  checkVersion,
  sdkSignature,
  getSignatureConfig
}



// WEBPACK FOOTER //
// ./src/utils/tools.js